import { route, string } from 'react-router-typesafe-routes';

export const GRANTS_TABLE_URL_KEY = 'grants';
export const BLACKLIST_TABLE_URL_KEY = 'blacklist';

export const DATA_ISOLATION_ROUTE = route({
    path: 'data-isolation',
    searchParams: {
        'grants.grantedAt': string(),
        'grants.ehrId': string(),
        'grants.userId': string(),
        'grants.source': string(),
        'grants.sort': string(),
        'blacklist.blockedAt': string(),
        'blacklist.ehrId': string(),
        'blacklist.doctorId': string(),
        'blacklist.sort': string(),
        'blacklist.query': string(),
    },
});

export const DATA_ISOLATION_NAV_LINK = DATA_ISOLATION_ROUTE.$buildPath({});
